// extracted by mini-css-extract-plugin
module.exports = {"comingsoon":"NewsTab_comingsoon_1-ca5"};